import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from "../../utils/gqlClient";
import { wrapQuery } from "../../utils/wrapQuery";
import { getClientId } from "../../utils/config";
export { logout };
var query = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query Logout($client: String!) {\n    logout(clientId: $client)\n  }\n"])));
async function logout() {
  return wrapQuery('logout', query, {
    client: getClientId()
  });
}